import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Table,
  FormGroup,
  Label,
} from 'reactstrap';
import { Form } from '@availity/form';
import Select from '@availity/select';
import '@availity/yup';
import * as yup from 'yup';
import { components } from 'react-select';

import * as leadsActions from '../../store/leads/actions';
import { selectLeadByQualified } from '../../selectors/lead';
import { useSelector, useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { Dots } from 'react-activity';
import { arrayToSelect } from '../../helpers/sharedFunction';

import LEAD_NEGATIVE_OUTCOMES from '../../config/negativeOutcomes';

const EXCESS_LEAD_NEGATIVE_OUTCOMES = ['in eccesso'];
const { Option } = components;

const NegativeOutcomeSelectOption = (props) => (
  <Option {...props}>
    {EXCESS_LEAD_NEGATIVE_OUTCOMES.includes(props.data.value) ? (
      <span className="font-weight-bold">
        <i className="bx bx-error-circle align-middle mr-1" />
        {props.children}
      </span>
    ) : (
      props.children
    )}
  </Option>
);

const CloseExcessLeads = ({ leads }) => {
  const [sent, setSent] = useState(false);
  const [negativeOutcome, setNegativeOutcome] = useState('');

  const leadsReadyToQualify = useSelector(
    selectLeadByQualified('readyToQualify'),
  );
  const includeLeads = leadsReadyToQualify.map((lead) => lead.id);

  leads = leads.filter((lead) => includeLeads.includes(lead.id));

  const loading = useSelector((state) => state.Leads.loading);
  const logs = useSelector((state) => state.Leads.logs);

  const dispatch = useDispatch();

  const handleCloseExcessLeads = () => {
    dispatch(leadsActions.closeExcessLeads(leads, negativeOutcome));
    setSent(true);
  };

  const { t } = useTranslation();

  const negativeOutcomesOptions = [
    ...EXCESS_LEAD_NEGATIVE_OUTCOMES,
    ...LEAD_NEGATIVE_OUTCOMES,
  ];

  return (
    <Card>
      <CardBody>
        <Row className="my-2">
          <Col md="12">
            <h4 className="text-center">
              {t('close_excess_leads', { countLeads: leads.length })}
            </h4>
          </Col>
        </Row>
        <Row className="my-2 justify-content-center">
          <Col md="4">
            <Form
              initialValues={{ negativeOutcome }}
              validationSchema={yup.object().shape({
                negativeOutcome: yup.string().required(),
              })}
            >
              <FormGroup>
                <Label htmlFor="negativeOutcome">
                  {t('close_excess_leads_reason_label')}
                </Label>
                <Select
                  name="negativeOutcome"
                  id="negativeOutcome"
                  isMulti={false}
                  onChange={(value) => setNegativeOutcome(value)}
                  value={negativeOutcome}
                  options={arrayToSelect(negativeOutcomesOptions, t)}
                  components={{ Option: NegativeOutcomeSelectOption }}
                />
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row className="my-2">
          <Col md="12" className="text-center">
            <Button
              color="danger"
              outline
              className="waves-effect waves-light"
              onClick={handleCloseExcessLeads}
              disabled={!leads.length || !negativeOutcome || sent}
            >
              <i className="bx bx-x-circle font-size-20 align-middle mr-2"></i>
              {t('Close Excess Leads')}
            </Button>
          </Col>
        </Row>
        {!!(sent && loading) && <Dots />}
        {!!(sent && logs.length) && (
          <Row className="my-2">
            <Col md="12">
              <div className="table-responsive">
                <Table className="table mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Lead ID</th>
                      <th>Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logs.map((log, index) => (
                      <tr key={log.leadId}>
                        <th scope="row">{index}</th>
                        <td>{log.leadId}</td>
                        <td>{log.response}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default CloseExcessLeads;
